import { InternalAxiosRequestConfig } from 'axios';
import Pako from 'pako';

/**
 * GZipで圧縮したいAPIはこれを指定する
 * @example - someApi.post(request, gzipRequestOptions)
 */
export const gzipRequestOptions = {
  headers: {
    'X-Leanpath-Gzip-Request': 'true',
  },
};

/**
 * requestBodyのJSONをgZipで圧縮する
 * @param config - Axios request
 */
export const toGzipRequest = (config: InternalAxiosRequestConfig) => {
  const shouldGzip = shouldCompressRequest(config);
  config.headers.delete('X-Leanpath-Gzip-Request');

  if (!shouldGzip) {
    return config;
  }

  const json = typeof config.data === 'string' ? config.data : JSON.stringify(config.data);
  const bytes = new TextEncoder().encode(json);
  const compressed = Pako.gzip(bytes);
  const arrayBuffer = compressed.buffer.slice(compressed.byteOffset, compressed.byteOffset + compressed.byteLength) as ArrayBuffer;

  config.headers.set('Content-Type', 'application/gzip');
  config.headers.set('X-Leanpath-Original-Content-Type', 'application/json');
  config.data = arrayBuffer;

  return config;
};

/**
 * requestを圧縮するべきかどうかを返す
 * @param config - Axios request
 */
const shouldCompressRequest = (config: InternalAxiosRequestConfig): boolean => {
  // 明示的に指定されているか
  if (config.headers.get('X-Leanpath-Gzip-Request') !== 'true') return false;
  // bodyがあるか
  if (config.data == null) return false;
  // POST/PUT/PATCHかどうか
  const method = config.method?.toLowerCase();
  if (!['post', 'put', 'patch'].includes(method ?? '')) return false;
  // JSONかどうか
  const contentType = config.headers.get('Content-Type');
  if (typeof contentType !== 'string' || !contentType.toLowerCase().includes('application/json')) {
    return false;
  }
  // すでに圧縮済みか(圧縮済みなら二重でやらない)
  if (config.headers.has('Content-Encoding')) {
    return false;
  }
  // 文字列化できるか
  try {
    typeof config.data === 'string' ? config.data : JSON.stringify(config.data);
  } catch {
    return false;
  }

  return true;
};
